'use strict';

module.exports = function (angularModule) {
  angularModule
      .factory('authTokenProvider', require('./authTokenProvider'))
      .service('eikonSsoService', require('./eikonSsoService'))
      .service('eikonLoginUrlRepository', require('./eikonLoginUrlRepository'))
      .service('goldmanSsoService', require('./goldmanSsoService'))
      .service('eikonAttributeRepository', require('./eikonAttributeRepository'))
      .factory('impersonationService', require('./impersonationService'))
      .service('winINetCookieRepository', require('./winINetCookieRepository'))
      .service('eikonHeartbeatRepository', require('./eikonHeartbeatRepository'))
      .factory('rediTokenService', require('./rediTokenService'))
      .constant('EIKON_SESSION_COOKIE_NAME', 'iPlanetDirectoryPro')
      .constant('DEVICE_COOKIE_NAME', 'rtDevice');
};



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/index.js
// module id = 111
// module chunks = 0